export default __webpack_public_path__ + "static/media/bgGreen120x176.c648ca02.jpg";